import { render, staticRenderFns } from "./SetupProfileTab.vue?vue&type=template&id=312f84ff&scoped=true"
import script from "./SetupProfileTab.vue?vue&type=script&lang=js"
export * from "./SetupProfileTab.vue?vue&type=script&lang=js"
import style0 from "./SetupProfileTab.vue?vue&type=style&index=0&id=312f84ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312f84ff",
  null
  
)

export default component.exports